import React, { useState } from 'react'
import './Layout.scss'
import { Navigation } from '../components/Navigation/Navigation'

export const Layout = props => {
    
    const [open, setOpen] = useState(false)

    return (
        <div className='Layout'>
            <Navigation
                isOpen = {open}
                setOpen={setOpen}
            />
            <main onClick={()=> setOpen(false) } >
                {props.children}
            </main>
        </div>
    )
}
